/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';

// router setup
import router from './routes/router';

import store from '@/store'
// plugin setup
Vue.use(DashboardPlugin);

// Internal bus setup
export const bus=new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  beforeCreate() { this.$store.commit('initialiseStore');},
  router
});
